import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mutate } from 'swr'
import { ProfileTypes } from 'types/enums'

import { assignCustomer } from 'services/api/formalization-bff/customer-triage/assign-customer'
import { redirectToCustomerTimeline } from 'facades/redirectToCustomerTimeline'
import { toastr } from 'components/Toastr'

export function useGetNextClient(profileType: ProfileTypes) {
  const { t } = useTranslation(['formalization'])
  const [loading, setLoading] = useState(false)

  const get = async () => {
    try {
      setLoading(true)
      const customer = await assignCustomer(profileType)
      redirectToCustomerTimeline(customer.applicationID)
      await mutate(`/formalization/triage/${profileType}`)
      setLoading(false)
    } catch {
      toastr.error(t('notifications.empty-queue'), { autoClose: 5000 })
      setLoading(false)
    }
  }

  return { get, loading }
}
